import { Component, input, Input } from '@angular/core';
import { BaseComponent } from '@ex/module/core/domain/base-component';
import { JsonToExcelComponent } from '../export-components/json-to-excel/json-to-excel.component';
import { PdfChartExporterComponent } from '../chart-exporter/pdf-chart-exporter/pdf-chart-exporter.component';
import { take } from 'rxjs/operators';
import { ExcelChartOptions } from '@ex/module/core/data-models/excel-chart-options';
import { ExportChartData } from '@ex/module/core/data-models/export-chart-options';
import { DashletData } from '@ex/module/core/data-models/dashlet-data';
import { Dashlet } from '@ex/module/core/data-models/dashlet';
import { SeriesType } from '@ex/module/core/modules/chart/utils/SeriesType';
import { Chart } from '@ex/module/core/modules/chart/builder';
enum ExportMode {
  Landscape = 'landscape',
  Portrait = 'portrait'
}

@Component({
  selector: 'app-chart-base',
  template: `
    <p>
      chart-base works!
    </p>
  `,
  styles: [
  ]
})
export abstract class ChartBaseComponent extends BaseComponent {
  entity: any;
  SeriesType = SeriesType;
  readonly chart = input<Chart>();
  isOpen = false
  @Input() export: boolean = false;
  @Input() singleExport: boolean = false;
  @Input('exportMode') set mode(mode) {
    if (mode == ExportMode.Portrait) {
      this.exportMode = mode;
      this.exportPageRows = 20;
    }
  }
  @Input() isClosedWithoutExport = true
  exportPageRows: number = 13;
  exportMode;
  data: any;
  dashlet: Dashlet;
  baseDashletData: DashletData


  exportBasePdf(elementId: any, data?: ExportChartData) {
    this.isOpen = true

    if (!data?.reportTitle && this.dashlet?.Title)
      data.reportTitle = this.dashlet.Title;
    this.singleExport = true
    this.LoaderService.displayLoader();
    this.export = true;
    this.exportMode = ExportMode.Portrait
    setTimeout(() => {
      this.initChartExpor(elementId, data)
    }, 1000);
  }

  initChartExpor(elementId, data?) {
    const element = document.getElementById(elementId);
    const chartHTML = element.cloneNode(true)
    this.ZenCDKService.openComponent(PdfChartExporterComponent, {
      chartHTML,
      elementId: elementId,
      ...data
    }).pipe(take(1)).subscribe({
      next: x => {
        this.singleExport = false;
        this.export = false;
        this.exportMode = this.mode
      }
    });

    if (this.isClosedWithoutExport) {
      this.singleExport = false;
      this.export = false;
      this.exportMode = this.mode
    }
  }


  exportExcel(title: string = this.dashlet?.Title, dashletData?: Partial<DashletData>, data: ExcelChartOptions = {}) {
    let chartData
    title = title ?? this.dashlet?.Title;

    if (this.baseDashletData.groupedChart) {
      data.grouping = true;
    }
    if (dashletData) {
      chartData = this.ChartExcelExportService.processData(dashletData)
    }
    else {
      chartData = this.ChartExcelExportService.processData(this.data)
    }

    this.ZenCDKService.openComponent(JsonToExcelComponent, {
      data: chartData,
      name: title,
      includeTitle: true,
      ...data,
      modify: this.modifyRow
    })
  }

  modifyRow = (row: any) => {
    row.eachCell((cell: any) => {
      if (typeof cell.value === 'number') {
        cell.value = isNaN(cell.value) ? 0 : cell.value;

        cell.numFmt = '0.0%';
        cell.value = cell.value / 100;
      }
    });
  };

}
